import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import CoreValues from "@/components/CoreValues";
import Mission from "@/components/Mission";
import Services from "@/components/Services";
import Products from "@/components/Products";
import Works from "@/components/Works";
import Insights from "@/components/Insights";
import ClientLogos from "@/components/ClientLogos";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import CookieConsent from "@/components/CookieConsent";

export default function Home() {
  useEffect(() => {
    document.title = "Makario — IT Consulting & Digital Transformation Indonesia";
    const root = document.querySelector(".snap-root");
    if (root) root.scrollTop = 0;
  }, []);

  return (
    <main data-testid="home-page" className="snap-root">
      <Navbar />
      <section id="hero" data-section="hero" className="snap-section"><Hero /></section>
      <section id="values" data-section="values" className="snap-section"><CoreValues /></section>
      <section id="mission" data-section="mission" className="snap-section"><Mission /></section>
      <section id="services" data-section="services" className="snap-section"><Services /></section>
      <section id="products" data-section="products" className="snap-section"><Products /></section>
      <section id="works" data-section="works" className="snap-section"><Works /></section>
      <section id="insights" data-section="insights" className="snap-section"><Insights /></section>
      <section id="clients" data-section="clients" className="snap-section"><ClientLogos /></section>
      <section id="contact" data-section="contact" className="snap-section"><Contact /></section>
      <section data-section="footer" className="snap-section" style={{ minHeight: "auto" }}><Footer /></section>
      <CookieConsent />
    </main>
  );
}
